<template>
  <div class="padding-10">
    <div class="d-flex">
      <v-spacer></v-spacer>
      <create-sms-template></create-sms-template>
    </div>
    <v-card :elevation="$root.ele" class="mt-5">
      <v-data-table
        :headers="headers"
        class="templates-table"
        :items="list"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, -1],
        }"
        :items-per-page="50"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex align-center">
            <create-sms-template :item="item"></create-sms-template>
            <remove-icon-button v-if="isAdmin"
              @click="removeTemplate(item)"
            ></remove-icon-button>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
  
  <script>
import { formatDate } from "../assets/js/common";
import CreateSmsTemplate from "../components/smsTemplates/CreateSmsTemplate.vue";
import RemoveIconButton from "../components/buttons/RemoveIconButton.vue";
import { smsTemplates } from "../assets/js/firebase";
export default {
  components: {
    CreateSmsTemplate,
    RemoveIconButton,
  },
  data() {
    return {
      id: "",
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "ID", value: "_id" },
        { text: "TEMPLATE TEXT", value: "text" },
        { text: "TEMPLATE TITLE", value: "title" },
        { text: "UPDATED ON", value: "updated_at" },
        { text: "UPDATED BY", value: "updated_by" },
        { text: "ACTION", value: "action" },
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
        };
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    list() {
      let list = this.$store.getters.smsTemplates;
      return [...list].map((i) => ({
        ...i,
        title: i.title || "-",
        updated_by: this.updatedBy(i),
        updated_at: formatDate(i.updated_at),
      }));
    },
    users() {
      return this.$store.getters.users;
    },
  },
  methods: {
    updatedBy({ updated_by }) {
      let name = updated_by;
      this.users.forEach((item) => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    removeTemplate({ id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to remove this sms template?",
        onConfirm: async () => {
          try {
            vm.$loader.show();
            await smsTemplates.doc(id).delete();
            vm.$loader.hide();
          } catch (error) {
            vm.$loader.hide();
            vm.$alert.show(error.message);
          }
        },
      });
    },
  },
};
</script>
  
  <style lang="scss"></style>
  